import React, { useState } from "react";
import LandingPage from "./components/LandingPage1";
//import SankeyPanelwater from "./components/SP";
import SankeyPanelwater from "./components/SankeyPanelwater3";

export default function App() {
  const [showLanding, setShowLanding] = useState(true);

  return showLanding ? (
    <LandingPage onStart={() => setShowLanding(false)} />
  ) : (
    <SankeyPanelwater />
  );
}